import dayjs from 'dayjs';

export const DateFormatMixin = {
    methods: {
        dayjsFormat(dateitem, format = 'YYYY-MM-DD'){
            return dayjs(dateitem).format(format);
        },
        setEndDate(date, format = 'YYYY-MM-DD') {
            return dayjs(date).add(1, 'day').format(format);
        },
        getToday(){
            return dayjs();
        }
    }
};